import { Link, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"

export function NavigationItem({ item: { scheduleId, title }, regimeId }) {
    const [group, id] = scheduleId.split("!")
    return (
        <Link onClick={go}>
            <Stack direction="row" spacing={1} alignItems="center">
                <Iconify icon="streamline:location-target-1-solid" />
                <Typography component="span" variant="body2">
                    {title.slice(0, -2) || "[Top Level]"}
                </Typography>
            </Stack>
        </Link>
    )

    function go() {
        navigate(`/app/schedules/${group}~${regimeId}!${id}`)
    }
}
